import styled from 'styled-components';

export const CarriersListStyled = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 24px;
  flex-wrap: wrap;
  width: 100%;
`;
